<script>
  import { format } from 'svelte-i18n';
  import { Dropdown, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import Items from './items.svelte';

  export let expanded = true;
  export let folders = [];
  export let selectable = false;
  export let selected = [];
  export let direction = 'down';
  export let selectedLabels = [];
  export let onSelect = () => {};

  const toggle = () => {
    expanded = !expanded;
  };
</script>

{#if folders?.length}
  <Dropdown isOpen={expanded} {toggle} {direction}>
    <DropdownToggle caret>
      <slot>
        {#if !selectedLabels.length}
          {$format('label.SELECT_FOLDERS')}
        {:else}
          {$format('label.FOLDER_LENGTH', { values: { length: selectedLabels.length } })}
        {/if}
      </slot>
    </DropdownToggle>
    <DropdownMenu class="padded-menu">
      {#each folders as folder}
        <Items name={folder.name} {selectable} {selected} {selectedLabels} {onSelect} {...folder} meta={folder} />
      {/each}
    </DropdownMenu>
  </Dropdown>
{/if}

<style lang="scss" src="./menu.scss"></style>
